import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconConsole: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconConsole"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V21H3V3ZM7.5 6.58579L10.6642 9.75L7.5 12.9142L6.08579 11.5L7.83579 9.75L6.08579 8L7.5 6.58579ZM11 10.5H15V12.5H11V10.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconConsole;
